import React from 'react';
import PropTypes from 'prop-types';

function GeneralizedTableRow({ rowData, columns }) {
  return (
    <tr>
      {columns.map((column, index) => {
        let cellContent;
        if (column.render && typeof column.render === 'function') {
          cellContent = column.render(rowData);
        } else {
          const attributePrefix = "Attributes.";
          const isAttribute = column.id.startsWith(attributePrefix);

          if (isAttribute) {
            const attributeName = column.id.slice(attributePrefix.length);
            const attributeValue = rowData.Attributes[attributeName];
            cellContent = column.format ? column.format(attributeValue) : attributeValue;
          } else {
            if (rowData[column.id] === undefined) {
              cellContent = column.format ? column.format(rowData) : rowData[column.id];
            } else {
              if (column.format) {
                cellContent = rowData[column.id] === null ? '' : column.format(rowData[column.id]);
              } else {
                cellContent = rowData[column.id] === null ? '' : rowData[column.id];
              }
            }
          }
        }

        const isLinkable = column.link && typeof column.link === 'function';
        const isAction = column.action && typeof column.action === 'function';
        const target = (isLinkable && column.target) || '_self';

        return (
          <td key={index} className={`whitespace-nowrap px-1 py-1.5 text-sm ${column.textColor || 'text-gray-700'}`}>
            {isLinkable ? (
              <a href={column.link(rowData)} className="text-custom-blue hover:text-custom-blue-dark" target={target}>
                {column.icon && <column.icon className="inline-block h-5 w-5 mr-2 text-gray-500" aria-hidden="true" title={column.tooltip || ''} />}
                {cellContent}
              </a>
            ) : isAction ? (
              <button onClick={() => column.action(rowData)} className="text-custom-blue hover:text-custom-blue-dark">
                {column.icon && <column.icon className="inline-block h-5 w-5 mr-2 text-gray-500" aria-hidden="true" title={column.tooltip || ''} />}
                {cellContent}
              </button>
            ) : (
              cellContent
            )}
          </td>
        );
      })}
    </tr>
  );
}

GeneralizedTableRow.propTypes = {
  rowData: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      link: PropTypes.func,
      icon: PropTypes.elementType,
      textColor: PropTypes.string,
      format: PropTypes.func,
      action: PropTypes.func,
      render: PropTypes.func,
      tooltip: PropTypes.string,
      target: PropTypes.string
    })
  ).isRequired,
};

export default GeneralizedTableRow;
